document.addEventListener("DOMContentLoaded", function () {
  // Code Here
});
